<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Gestione Ricerca </v-toolbar-title>
      <v-spacer></v-spacer>

      <!-- Bottone per aggiungere filtri -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="
              modalita === 'tabella'
                ? nuovoFiltroPersonalizzato()
                : nuovoFiltroDettaglio()
            "
            class="mr-5"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-plus </v-icon>
          </v-btn>
        </template>
        <span>{{
          modalita === "tabella"
            ? "Nuovo Filtro Personalizzato"
            : "Nuovo Parametro di Filtro"
        }}</span>
      </v-tooltip>

      <!-- Bottone di salvataggio del dettaglio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="setRicercaDettaglio"
            small
            v-bind="attrs"
            v-show="modalita === 'dettaglio'"
            v-on="on"
          >
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Salva</span>
      </v-tooltip>

      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="modalita === 'tabella' ? clickChiudi() : tornaATabella()"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="error">
              {{
                modalita === "tabella" ? "mdi-close" : "mdi-keyboard-backspace"
              }}
            </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text>
      <v-container class="px-0" fluid>
        <v-row dense v-if="modalita === 'tabella'">
          <v-col cols="12">
            <v-data-table
              fixed-header
              :headers="headers_ricerche_selezionabili"
              height="70vh"
              :items="items_ricerche_selezionabili"
            >
              <!-- Bottone di selezione -->
              <template v-slot:[`item.seleziona`]="{ item }">
                <v-btn @click="selezionaRicerca(item)" small>
                  <v-icon color="primary"> mdi-magnify </v-icon>
                </v-btn>
              </template>

              <!-- Titolo del set di filtri -->
              <template v-slot:[`item.modifica`]="{ item }">
                <v-btn @click="editFiltroPersonalizzato(item)" small>
                  <v-icon color="primary"> mdi-pencil </v-icon>
                </v-btn>
              </template>

              <!-- Bottone di eliminazione -->
              <template v-slot:[`item.elimina`]="{ item }">
                <v-btn @click="clickEliminaRicerca(item)" small>
                  <v-icon color="error"> mdi-delete </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row dense v-else>
          <v-col cols="12">
            <v-row dense>
              <v-col cols="6">
                <v-text-field
                  dense
                  hide-details
                  label="Struttura Logica"
                  outlined
                  style="border-radius: 0px"
                  v-model="ricerca_sel.struttura_logica"
                >
                  <template v-slot:append-outer>
                    <!-- Bottone di reset -->
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="refreshStrutturaLogica"
                          small
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="primary"> mdi-refresh </v-icon>
                        </v-btn>
                      </template>
                      <span>Reset</span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <!-- Mostra i filtri dettaglio. -->
            <v-data-table
              fixed-header
              :headers="headers_ricerca_dettaglio"
              :items="items_ricerca_dettaglio.filter((e) => e.validita == 1)"
              disable-sort
            >
              <!-- Pulsante sposta su. -->
              <template v-slot:[`item.up`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="ma-0 pa-0"
                      small
                      v-bind="attrs"
                      v-on="on"
                      :disabled="items_ricerca_dettaglio.indexOf(item) == 0"
                      @click="spostaOrdineFiltro(true, item)"
                    >
                      <v-icon color="primary">mdi-arrow-up</v-icon>
                    </v-btn>
                  </template>
                  <span> Sposta su </span>
                </v-tooltip>
              </template>

              <!-- Pulsante sposta giù. -->
              <template v-slot:[`item.down`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="ma-0 pa-0"
                      small
                      v-bind="attrs"
                      v-on="on"
                      :disabled="
                        items_ricerca_dettaglio.indexOf(item) ==
                        items_ricerca_dettaglio.length - 1
                      "
                      @click="spostaOrdineFiltro(false, item)"
                    >
                      <v-icon color="primary">mdi-arrow-down</v-icon>
                    </v-btn>
                  </template>
                  <span> Sposta giù </span>
                </v-tooltip>
              </template>

              <!-- Descrizione filtro. -->
              <template v-slot:[`item.des_ricerca_dettaglio`]="{ item }">
                <v-text-field
                  dense
                  hide-details
                  v-model="item.des_ricerca_dettaglio"
                >
                </v-text-field>
              </template>

              <!-- Campo tabella (modificabile solo da "Default"). -->
              <template v-slot:[`item.campo`]="{ item }">
                <v-text-field dense hide-details v-model="item.campo">
                </v-text-field>
              </template>

              <!-- Operatore relazionale. -->
              <template v-slot:[`item.operatore`]="{ item }">
                <v-autocomplete
                  dense
                  hide-details
                  :items="items_operatori_rel"
                  item-text="des"
                  item-value="val_int"
                  v-model="item.operatore"
                >
                </v-autocomplete>
              </template>

              <!-- Tipo oggetto del valore da confrontare. -->
              <template v-slot:[`item.tipo_oggetto`]="{ item }">
                <v-autocomplete
                  dense
                  hide-details
                  :items="items_tipi_oggetto"
                  item-text="des"
                  item-value="val_int"
                  v-model="item.tipo_oggetto"
                  @change="
                    item.valore = null;
                    if (
                      item.tipo_oggetto != tipo_oggetto.MULTI_SELECT &&
                      item.tipo_oggetto != tipo_oggetto.SELECT
                    ) {
                      item.query_tabella = null;
                      item.lista_query = [];
                    }
                  "
                >
                </v-autocomplete>
              </template>

              <!-- Valore (tipo oggetto a seconda di quello selezionato). -->
              <template v-slot:[`item.valore`]="{ item }">
                <v-text-field
                  dense
                  hide-details
                  v-if="item.tipo_oggetto == tipo_oggetto.TEXT_FIELD"
                  v-model="item.valore"
                >
                </v-text-field>

                <v-text-field
                  type="date"
                  dense
                  hide-details
                  v-if="item.tipo_oggetto == tipo_oggetto.DATA_PICKER"
                  v-model="item.valore"
                >
                </v-text-field>

                <template v-if="item.tipo_oggetto == tipo_oggetto.DATA_QUERY">
                  <v-card-text class="d-flex ma-0 pa-0">
                    <v-text-field
                      dense
                      hide-details
                      class="mr-4"
                      type="number"
                      reverse
                      :value="convertiDataQuery(item.valore, true)"
                      @change="
                        (e) => {
                          aggiornaValoreDataQuery(e, item, true);
                        }
                      "
                    ></v-text-field>

                    <v-autocomplete
                      dense
                      hide-details
                      :items="items_date"
                      item-text="text"
                      item-value="value"
                      :value="convertiDataQuery(item.valore, false)"
                      @change="
                        (e) => {
                          aggiornaValoreDataQuery(e, item, false);
                        }
                      "
                    >
                    </v-autocomplete>
                  </v-card-text>
                </template>

                <template
                  v-if="
                    item.tipo_oggetto == tipo_oggetto.SELECT ||
                    item.tipo_oggetto == tipo_oggetto.MULTI_SELECT
                  "
                >
                  <v-card-text class="d-flex ma-0 pa-0">
                    <v-autocomplete
                      dense
                      hide-details
                      :multiple="item.tipo_oggetto == tipo_oggetto.MULTI_SELECT"
                      :items="item.lista_query"
                      item-text="text"
                      item-value="value"
                      v-model="item.valore"
                    >
                    </v-autocomplete>

                    <!-- Pulsante per riempire la multi-select con query. -->
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          light
                          style="position: relative; top: 3px; margin-left: 5px"
                          v-on="on"
                          v-bind="attrs"
                          @click="
                            dialog_query = true;
                            item_query_sel = item;
                            query_valori.query = item_query_sel.query_tabella;
                          "
                        >
                          <v-icon color="primary"> mdi-database-search </v-icon>
                        </v-btn>
                      </template>
                      <span>Query valori</span>
                    </v-tooltip>
                  </v-card-text>
                </template>
              </template>

              <!-- Pulsante visibilità. -->
              <template v-slot:[`item.visible`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      v-if="item.visible == 1"
                      v-bind="attrs"
                      v-on="on"
                      @click="item.visible = 0"
                    >
                      <v-icon color="primary">mdi-eye</v-icon>
                    </v-btn>

                    <v-btn
                      small
                      v-else
                      v-bind="attrs"
                      v-on="on"
                      @click="item.visible = 1"
                    >
                      <v-icon color="error">mdi-eye-off</v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    item.visible == 0 ? "Invisibile" : "Visibile"
                  }}</span>
                </v-tooltip>
              </template>

              <!-- Tipo valore header. -->
              <template v-slot:[`item.tipo_filtro`]="{ item }">
                <v-text-field dense v-model="item.tipo_filtro"> </v-text-field>
              </template>

              <!-- Pulsante attiva / disattiva. -->
              <template v-slot:[`item.validita`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      small
                      v-bind="attrs"
                      v-on="on"
                      @click="item.validita = 0"
                    >
                      <v-icon color="error">mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Elimina</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- Dialog titolo nuova ricerca -->
    <v-dialog
      v-model="dialog_des_ricerca"
      width="80%"
      persistent
      style="overflow-x: hidden"
    >
      <v-card style="overflow-x: hidden">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Dettaglio Set Filtri
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Pulsante di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="setRicerca"
                :disabled="!query_valori.is_analyzed"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer></v-spacer>

          <!-- Pulsante di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_des_ricerca = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto; overflow: hidden">
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col class="my-0" justify="center" cols="4">
                <v-text-field
                  dense
                  hide-details
                  label="Des. Filtri"
                  @keydown.enter="setRicerca"
                  outlined
                  style="border-radius: 0px"
                  v-model="ricerca_sel.des_ricerca"
                ></v-text-field>
              </v-col>
              <v-col cols="8">
                <div>
                  <h2>Query:</h2>
                </div>
              </v-col>
            </v-row>
            <v-row align="start" justify="center">
              <v-col cols="4">
                <div>
                  <h2>Placeholder:</h2>
                  <div class="my-3" style="font-size: 18px">
                    [filterFiltri_where]
                  </div>
                </div>
                <div>
                  <h2>Parametri:</h2>
                </div>
                <v-textarea
                  no-resize
                  outlined
                  :rows="stringa_modello.split('\n').length"
                  class="mt-2"
                  readonly
                  style="border-radius: 0px"
                  v-model="stringa_modello"
                />
              </v-col>
              <v-col class="my-0" justify="center" cols="8">
                <QueryEditor
                  :key="ricerca_sel.query"
                  v-model="ricerca_sel"
                  @analyze="analizzaQuery"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione -->
    <v-dialog v-model="conferma_elimina_dialog" width="unset" persistent>
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler eliminare questo set di filtri?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="conferma_elimina_dialog = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="eliminaRicerca" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Popup query per riempire multi-select. -->
    <v-dialog persistent v-model="dialog_query" width="800px">
      <v-card>
        <!-- Toolbar. -->
        <v-toolbar dense color="primary" dark align="center">
          <v-toolbar-title> Query </v-toolbar-title>
          <v-spacer />

          <!-- Conferma le modifiche. -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                light
                class="ml-5"
                :disabled="!query_valori.is_analyzed"
                @click="
                  dialog_query = false;
                  item_query_sel.query_tabella = query_valori.query;
                "
              >
                <v-icon color="success"> mdi-check </v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>

          <v-spacer />
          <!-- Pulsante indietro. -->
          <v-btn
            small
            light
            @click="
              dialog_query = false;
              query_valori.query = '';
            "
          >
            <v-icon color="error">mdi-keyboard-backspace</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <!-- Text editor per query. -->
          <QueryEditor
            class="mt-5"
            :key="query_valori.query"
            v-model="query_valori"
            @analyze="analizzaQuery"
          />

          <!-- Pulsante per eseguire la query. -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                v-on="on"
                v-bind="attrs"
                :disabled="!query_valori.is_analyzed"
                @click="
                  eseguiQuery(item_query_sel, true);
                  item_query_sel.valore = null;
                "
              >
                Esegui
              </v-btn>
            </template>
            <span>Esegui query</span>
          </v-tooltip>

          <!-- Lista risultato query. -->
          <v-data-table
            v-if="item_query_sel"
            fixed-header
            class="mt-1"
            :headers="headers_query"
            :items="item_query_sel.lista_query"
            disable-sort
            height="200px"
          />
        </v-card-text>
      </v-card>

      <!-- Overlay caricamento. -->
      <v-overlay
        color="rgba(0, 0, 0, 1)"
        style="position: absolute"
        :value="caricamento_dati_dialog"
      >
        <v-icon class="ConsuntivoWORuota" size="100">mdi-cog</v-icon>
        <v-icon class="ConsuntivoWOControruota" size="100">mdi-cogs</v-icon>
      </v-overlay>
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="caricamento_dati" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import moment from "moment/moment";
import QueryEditor from "@/components/GRAPH/Dashboard/Editor/QueryParser/QueryEditor.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "GestioneRicerca",
  components: {
    QueryEditor,
    SnackbarQV,
  },
  props: {
    modulo: {
      type: String,
      default: "",
    },
    stringa_modello: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      item_query_sel: null,
      modalita: "tabella",
      query_valori: { query: null, is_analyzed: false },
      ricerca_sel: new Object(),
      tipo_oggetto: {
        TEXT_FIELD: 0,
        DATA_PICKER: 1,
        DATA_QUERY: 2,
        MULTI_SELECT: 3,
        SELECT: 4,
      },

      // Modal
      dialog_query: false,
      caricamento_dati: false,
      caricamento_dati_dialog: false,
      conferma_elimina_dialog: false,
      dialog_des_ricerca: false,

      // Array
      headers_query: [
        { text: "Descrizione (AS text)", value: "text", width: "280px" },
        { text: "Valore (AS value)", value: "value" },
      ],
      headers_ricerca_dettaglio: [
        { text: "", value: "up", width: "30px" },
        { text: "", value: "down", width: "30px" },
        { text: "Num. filtro", value: "id_ricerca_dettaglio_tmp" },
        { text: "Des. filtro", value: "des_ricerca_dettaglio" },
        { text: "Campo tabella", value: "campo" },
        { text: "Operatore", value: "operatore", width: "150px" },
        { text: "Tipo Oggetto", value: "tipo_oggetto", width: "150px" },
        { text: "Valore", value: "valore", width: "280px" },
        //{ text: "Tipo filtro", value: "tipo_filtro", width: "100px" },
        //{ text: "Visibilità", value: "visible" },
        { text: "Elimina", value: "validita" },
      ],
      headers_ricerche_selezionabili: [
        {
          text: "",
          value: "seleziona",
          sortable: false,
          width: "100px",
        },
        {
          text: "",
          value: "modifica",
          sortable: false,
          width: "100px",
        },
        {
          text: "Descrizione",
          value: "des_ricerca",
          sortable: false,
        },
        {
          text: "",
          value: "elimina",
          sortable: false,
          width: "100px",
        },
      ],
      items_date: [
        { text: "Giorni", value: "DAY" },
        { text: "Mesi", value: "MONTH" },
        { text: "Mesi (inizio)", value: "START_MONTH" },
        { text: "Mesi (fine)", value: "END_MONTH" },
        { text: "Anni", value: "YEAR" },
        { text: "Anni (inizio)", value: "START_YEAR" },
        { text: "Anni (fine)", value: "END_YEAR" },
      ],
      items_operatori_rel: new Array(),
      items_ricerca_dettaglio: new Array(),
      items_ricerche_selezionabili: new Array(),
      items_tipi_oggetto: new Array(),
    };
  },
  computed: {},
  watch: {},
  methods: {
    // Converti i valori di data query dai due form al formato stringa.
    aggiornaValoreDataQuery(e, item, is_num) {
      var tmp_val = ["0", "DAY"];
      if (item.valore) tmp_val = item.valore.split("/");
      if (is_num) tmp_val[0] = e;
      else tmp_val[1] = e;
      item.valore = tmp_val[0] + "/" + tmp_val[1];
    },
    analizzaQuery(status) {
      this.query_valori.is_analyzed = !status;
    },
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    clickEliminaRicerca(arg) {
      this.ricerca_sel = JSON.parse(JSON.stringify(arg));
      this.conferma_elimina_dialog = true;
    },
    // Converti i valori di data query da stringa a formato leggibile dal form.
    convertiDataQuery(val, is_num) {
      if (val) {
        var data_query = val.split("/");
        if (is_num) return data_query[0];
        else return data_query[1];
      }
    },
    editFiltroPersonalizzato(arg) {
      this.ricerca_sel = {
        id_ricerca: arg.id_ricerca,
        query: arg.query,
        des_ricerca: arg.des_ricerca,
      };
      this.dialog_des_ricerca = true;
    },
    eliminaRicerca() {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setricerca",
          token: localStorage.user_token,
          ricerche: [
            {
              id_ricerca: this.ricerca_sel.id_ricerca,
              validita: 0,
            },
          ],
          dettagli: [],
        },
      };

      this.caricamento_dati = true;
      this.conferma_elimina_dialog = false;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            this.getRicerche();
            this.$emit("update_filtri");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    eseguiQuery(item, from_dialog_query) {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "performquery",
          query_string: this.query_valori.query,
          token: localStorage.user_token,
        },
      };

      if (from_dialog_query) this.caricamento_dati_dialog = true;
      else this.caricamento_dati = true;

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (from_dialog_query) this.caricamento_dati_dialog = false;
          else this.caricamento_dati = false;

          if (res.data.result != null) {
            item.lista_query = res.data.result.Table;
            if (item.lista_query) {
              // Qualsiasi risultato (int, float, ecc...) dev'essere convertito in stringa.
              item.lista_query.forEach((e) => {
                e.value = e.value ? e.value.toString() : null;
              });
              // Riordina in ordine alfabetico.
              item.lista_query.sort((a, b) =>
                (a.text ? a.text : "").localeCompare(b.text ? b.text : "")
              );
            }
          } else {
            this.$refs.SnackbarQV.print("orange", "Nessuna query trovata.");
          }

          if (!from_dialog_query) this.aggiornaFiltriDettaglio();
        })
        .catch((err) => {
          if (from_dialog_query) this.caricamento_dati_dialog = false;
          else this.caricamento_dati = false;

          this.$refs.SnackbarQV.print(
            "error",
            err + ": ricontrollare che la query sia scritta correttamente."
          );
        });
    },
    getIdTmp() {
      let res = 1;
      this.items_ricerca_dettaglio.forEach((e) => {
        if (e.id_ricerca_dettaglio_tmp >= res) {
          res++;
        }
      });

      return res;
    },
    getRicerca() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getricerca",
          token: localStorage.user_token,
          id_ricerca: this.ricerca_sel.id_ricerca,
        },
      };

      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            this.items_ricerca_dettaglio = res.data.result.ricerca_dettaglio;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    getRicerche() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getricercheselezionabili",
          token: localStorage.user_token,
          modulo: this.modulo,
        },
      };

      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            this.items_ricerche_selezionabili = res.data.result.ricerche;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    getTabella() {
      //this.caricamento_dati = true;
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.user_token,
          tipo: "'TIPO_OGGETTO_FILTRI','OPERATORI_REL'",
          filter: "validita = 1",
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          //this.caricamento_dati = false;
          if (res.status === 200) {
            if (res.data) {
              this.items_tipi_oggetto = res.data.TIPO_OGGETTO_FILTRI
                ? res.data.TIPO_OGGETTO_FILTRI
                : new Array();
              this.items_tipi_oggetto.sort((a, b) => a.val_int - b.val_int);

              this.items_operatori_rel = res.data.OPERATORI_REL
                ? res.data.OPERATORI_REL
                : new Array();
              this.items_operatori_rel.sort((a, b) => a.val_int - b.val_int);
            }
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((err) => {
          //this.caricamento_dati = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    nuovoFiltroDettaglio() {
      const nuovo_id = this.getIdTmp();
      this.items_ricerca_dettaglio.push({
        id_ricerca: this.ricerca_sel.id_ricerca,
        ordine: null,
        id_ricerca_dettaglio: -moment().valueOf(),
        id_ricerca_dettaglio_tmp: nuovo_id,
        des_ricerca_dettaglio: null,
        campo: null,
        operatore: null,
        tipo_oggetto: this.tipo_oggetto.TEXT_FIELD,
        valore: null,
        tipo_filtro: null,
        query_tabella: null,
        visible: 1,
        validita: 1,
      });

      this.ricerca_sel.struttura_logica =
        this.ricerca_sel.struttura_logica != "" &&
        this.ricerca_sel.struttura_logica != null
          ? this.ricerca_sel.struttura_logica + ` AND {${nuovo_id}}`
          : `WHERE {${nuovo_id}}`;
    },
    nuovoFiltroPersonalizzato() {
      this.ricerca_sel = { id_ricerca: -1, des_ricerca: "", query: "" };
      this.dialog_des_ricerca = true;
    },
    refreshStrutturaLogica() {
      // Vuoto la stringa.
      this.ricerca_sel.struttura_logica = "";

      // Ripopolo la stringa in base ai miei filtri
      this.items_ricerca_dettaglio
        .filter((elem) => elem.validita == 1)
        .forEach((elem) => {
          this.ricerca_sel.struttura_logica =
            this.ricerca_sel.struttura_logica != "" &&
            this.ricerca_sel.struttura_logica != null
              ? this.ricerca_sel.struttura_logica +
                ` AND {${elem.id_ricerca_dettaglio_tmp}}`
              : `WHERE {${elem.id_ricerca_dettaglio_tmp}}`;
        });
    },
    selezionaRicerca(arg) {
      this.ricerca_sel = JSON.parse(JSON.stringify(arg));
      this.modalita = "dettaglio";
      this.getRicerca();
    },
    setRicerca() {
      // Controllo che ci sia un titolo valido.
      if (
        this.ricerca_sel.des_ricerca == null ||
        this.ricerca_sel.des_ricerca == ""
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Indicare un titolo per identificare il set di filtri."
        );
        return;
      }

      // Preparo la request e faccio il dispatch.
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setricerca",
          token: localStorage.user_token,
          ricerche: [
            {
              id_ricerca: this.ricerca_sel.id_ricerca,
              des_ricerca: this.ricerca_sel.des_ricerca,
              query: this.ricerca_sel.query,
              modulo: this.modulo,
            },
          ],
          dettagli: [],
        },
      };

      this.dialog_des_ricerca = false;
      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            this.getRicerche();
            this.$emit("update_filtri");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    setRicercaDettaglio() {
      // Controllo che ci sia un titolo valido.
      if (
        this.ricerca_sel.des_ricerca == null ||
        this.ricerca_sel.des_ricerca == ""
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Indicare un titolo per identificare il set di filtri."
        );
        return;
      }

      // Preparo la request e faccio il dispatch.
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setricerca",
          token: localStorage.user_token,
          ricerche: [
            {
              id_ricerca: this.ricerca_sel.id_ricerca,
              struttura_logica: this.ricerca_sel.struttura_logica,
            },
          ],
          dettagli: this.items_ricerca_dettaglio.filter(
            (e) => e.id_ricerca_dettaglio > 0 || e.validita == 1
          ),
        },
      };

      // Rimuovo le informazioni non necessarie.
      request.richiesta.dettagli.forEach((e) => {
        if (e.lista_query) {
          delete e.lista_query;
        }
      });

      // Eseguo il dispatch e gestisco la response.
      this.caricamento_dati = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.caricamento_dati = false;
          if (res.status === 200) {
            this.$refs.SnackbarQV.print("success", "Salvataggio eseguito.");
            this.getRicerca();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.caricamento_dati = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    spostaOrdineFiltro(is_up, item) {
      let i = is_up ? -1 : 1;
      let tmp_item = Object.assign({}, item);
      Object.assign(
        item,
        this.items_ricerca_dettaglio[
          this.items_ricerca_dettaglio.indexOf(item) + i
        ]
      );
      Object.assign(
        this.items_ricerca_dettaglio[
          this.items_ricerca_dettaglio.indexOf(item) + i
        ],
        tmp_item
      );
    },
    tornaATabella() {
      this.modalita = "tabella";
      this.getRicerche();
    },
  },
  created() {},
  mounted() {
    this.getRicerche();
    this.getTabella();
  },
};
</script>
<style scoped>
</style>